<template>
  <div class="vod-series">
    <ul>
      <li v-for="(cell, index) in cellList" :key="'series_cell_' + index" :class="selectOn(cell, index) ? 'playnow' : ''" @click.prevent="()=>selectCell(cell)">
        <a href="#">
          <span class="vod-series-img-wrap">
            <span class="vod-series-img">
                <div class="tag-top tag-list" v-top-tag-list="cell.top_taglist"></div>
                <img v-lazy="getLazyLoadObj(cell)" />
                <span class="progress-wrap">
                  <div class="progress-bar" v-if="cell.progress !== ''" v-progress-bar="cell.progress * 100"></div>
                </span>
            </span>
          </span>
          <span class="vod-series-info">
            <span class="vod-series-txt" v-title-list="{'titleList': cell.title_list, 'sixweekholdback': cell.sixweekholdback}"></span>
            <span class="vod-series-time">{{cell.time}}</span>
          </span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { resizeThumbnail } from '@/common/image.filter'
import { get } from 'lodash'
import { parseUrl } from 'query-string'
import { getEventListByType } from '@/common/util/event.util'
import { progressBar, titleList, topTagList } from '@/common/directives'
import { EventBus } from '@/components/eventbus/EventBus'
import { ON_CLICK } from '@/common/event.const'

export default {
  name: 'SeriesCellList',
  props: {
    cellList: {
      type: Array
    },
    thumbnailInfo: {
      type: Object
    },
    containerClassName: {
      type: String
    },
    contentInfo: {
      type: Object
    }
  },
  directives: {
    progressBar,
    titleList,
    topTagList
  },
  data () {
    return {
      selectedContentId: '',
      routeQueryId: ''
    }
  },
  methods: {
    getLazyLoadObj (cell) {
      return {
        src: resizeThumbnail(cell.thumbnail, this.thumbnailInfo),
        error: this.thumbnailInfo.loadingImageUrl,
        loading: this.thumbnailInfo.loadingImageUrl
      }
    },
    selectCell (cell) {
      const { onNavigationEvent, onClickEvent } = getEventListByType(cell.event_list)
      if (onClickEvent) {
        EventBus.$emit(ON_CLICK, onClickEvent)
      }
      let navigationUrl = get(onNavigationEvent, 'url', '').replace('.html', '')
      let { url, query } = parseUrl(navigationUrl)
      const fromList = get(this.$route, ['query', 'list'], 'n').toLowerCase() === 'y'
      const referer = get(this.$route, ['query', 'referer'], null)
      if (referer !== null) {
        if (fromList) {
          query.referer = this.$route.fullPath
          query.list = 'y'
        } else {
          query.referer = referer
        }
      }
      let section = url.split('/').pop()
      this.$router.push({
        name: 'player',
        params: {
          section
        },
        query: query
      })
    },
    selectOn (cell) {
      const { onNavigationEvent } = getEventListByType(cell.event_list)
      const { query } = parseUrl(onNavigationEvent.url)
      return this.selectedContentId === get(query, 'contentid', '')
    },
    topTag (topTagList) {
      let tagClass = topTagList.map((tag) => {
        if (tag !== '') {
          return 'tag-top'
        }
      })
      return get(tagClass, [0], '')
    }
  },
  created () {
    this.selectedContentId = get(this.contentInfo, 'contentid', null)
  },
  watch: {
    contentInfo () {
      this.selectedContentId = get(this.contentInfo, 'contentid', null)
    }
  }
}
</script>

<style scoped>
  /*------------------------------------*\
      vod 회차 있는 경우, 전체 회차 탭
  \*------------------------------------*/
  .tag-top {
    position: absolute;
    left: 5px;
    top: 5px;
  }
  .vod-series li{
    display: flex;
    flex-direction: column;
  }
  .vod-series li.playnow{
    background-color: #252525;
  }
  .vod-series a{
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px 10px;
    border-bottom: 1px solid #2f2f2f
  }
  .vod-series-img-wrap{
    position: relative;
  }
  .vod-series-img{
    position: relative;
    display: block;
    width: 118px;
    border: 1px solid rgba(0, 0, 0, .05)
  }
  .vod-series-img img {
    width: 116px;
  }
  /* vod - 프로그레스 바 */
  .progress-wrap{
    position: absolute;
    bottom: 0;
    width: 100%;
    display: block;
    margin-top: auto;
    height: 3px;
    background: rgba(0, 0, 0, 0.15)
  }
  .progress-bar{
    width: 50%;/* width 임의로 넣음 */
    display: block;
    height: 3px;
    background-color: #1351f9;
  }

  /* 첫번째 vod 재생 overlay */
  .vod-playnow:after{
    position: absolute;
    display: block;
    content: '';
    top: 50%;
    margin-top: -18px;
    left: 50%;
    margin-left: -18px;
    width: 36px;
    height: 36px;
    background: url(/img/common/ic-now-play.png);
    background-size: 36px 36px;
    z-index: 200;
  }

  /* vod 시리즈 인포 */
  .vod-series-info{
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    margin-left: 10px;
    font-size: 14px;
    line-height: 18px;
    color: #23212a
  }
  .vod-series-txt{
    display: block;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .vod-series-txt.select {
    font-weight: 700;
  }
  .vod-series-time{
    margin-top: 2px;
    font-size: 12px;
    line-height: 16px;
    color: #777
  }
</style>
